// extracted by mini-css-extract-plugin
module.exports = {"icons":"c0Dy1hg-K9oJHMZW_zTBy","shadow":"_2pC-4Lhy540OfjSX1Pj-A6"};